/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
export const addPassiveEventListener = (target: any, eventName: any, listener: any) => {
  const supportsPassiveOption = (() => {
    let supportsPassiveOption = false;
    try {
      const opts = Object.defineProperty({}, "passive", {
        get: () => {
          supportsPassiveOption = true;
        },
      });
      window.addEventListener("test", null, opts);
    } catch (e) { }
    return supportsPassiveOption;
  })();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

export const removePassiveEventListener = (target: any, eventName: any, listener: any) => {
  target.removeEventListener(eventName, listener);
};
